export const funcTips = [
  {
    key: "mainPage",
    title: "首页",
  },
  {
    key: "product",
    title: "产品中心",
  },
  {
    key: "solution",
    title: "解决方案",
  },
  {
    key: "download",
    title: "试用下载",
  },
  // {
  //   key: "support",
  //   title: "服务支持",
  // },
  {
    key: "tech",
    title: "技术前沿",
  },
  {
    key: "ours",
    title: "关于我们",
  },
];